import { render, staticRenderFns } from "./privaceAndPolicies.vue?vue&type=template&id=47acf432&scoped=true&"
import script from "./privaceAndPolicies.vue?vue&type=script&lang=js&"
export * from "./privaceAndPolicies.vue?vue&type=script&lang=js&"
import style0 from "./privaceAndPolicies.vue?vue&type=style&index=0&id=47acf432&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47acf432",
  null
  
)

export default component.exports